/** Module-level preload cache for GraphicDifference thumbnail URLs. */
export const imageReadyCache: Record<string, boolean> = {};

/** Clears preload cache entries for URLs containing this difference id (e.g. after unlink before re-draw). */
export function clearGraphicThumbnailCacheForDifferenceId(differenceId: string) {
  for (const key of Object.keys(imageReadyCache)) {
    if (key.includes(differenceId)) {
      delete imageReadyCache[key];
    }
  }
}
